var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clients"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('heading',{attrs:{"type":"h1"}},[_vm._v("Campaigns")])],1)]),_vm._v("\n\n    Campaigns - not used\n    ")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-430def1a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/campaigns/campaigns.vue
// module id = null
// module chunks = 